import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { FaIconLibrary } from "@fortawesome/angular-fontawesome";
import {
    faBolt,
    faPause,
    faChevronUp,
    faChevronDown,
    faArrowLeft,
    faPenToSquare,
    faTrash,
    faPlay,
    faPlus,
    faMinus,
    faUsd,
    faEye,
    faCheck,
    faHome,
    faCaretDown,
    faCaretUp,
    faChevronRight,
    faBars,
    faUser,
    faRobot,
    faBuildingColumns,
    faShop,
    faTimes,
    faClockRotateLeft,
    faMagnifyingGlass,
    faCircleQuestion,
    faFlask,
    faInfo,
    faDownload,
    faRightFromBracket,
    faSpinner,
    faToolbox,
    faListCheck,
    faMagnifyingGlassChart,
    faFloppyDisk,
    faPuzzlePiece,
    faArrowTrendUp,
    faCoins,
    faRocket,
    faDollar,
    faStop,
    faStar,
    faCircleUser,
    faTrashCan,
    faSpellCheck,
    faBarsProgress,
    faMoneyCheckDollar,
    faEllipsis,
    faEllipsisVertical,
    faReceipt,
    faHeadset,
    faCommentDots,
    faRotateRight,
    faChevronLeft,
    faThumbsUp,
    faWandSparkles,
    faUserGear,
    faLink,
    faSun,
    faMoon,
    faCircleInfo,
    faTriangleExclamation,
    faFileInvoiceDollar,
    faKey,
} from "@fortawesome/free-solid-svg-icons";
import { RouterService } from "../../../shared/_services/router.service";
import { PendingRequestInterceptor } from "../../../shared/_interceptors/pending-http-request.interceptor";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { filter, map, mergeMap } from "rxjs/operators";
import { Title } from "@angular/platform-browser";
import { ErrorHandlerService } from "../../../shared/_services/error-handler.service";
import { GeneralErrorHandlerService } from "./_shared/services/general-error-handler.service";
import { ThemeService } from "../../../shared/_services/theme.service";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrl: "./app.component.scss",
    standalone: false,
    changeDetection: ChangeDetectionStrategy.Eager,
})
export class AppComponent implements OnInit {
    public showLoader: boolean = false;

    constructor(
        private library: FaIconLibrary,
        private routerService: RouterService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private pendingRequestInterceptor: PendingRequestInterceptor,
        private titleService: Title,
        private errorHandlerService: ErrorHandlerService,
        private generalErrorHandlerService: GeneralErrorHandlerService,
        private translateService: TranslateService,
        private themeService: ThemeService,
    ) {
        this.errorHandlerService.registerHandler(this.generalErrorHandlerService);
        // Add an icon to the library for convenient access in other components
        this.pendingRequestInterceptor.pendingRequestsStatus.subscribe((status: boolean) => {
            setTimeout(() => {
                this.showLoader = status;
            });
        });
        this.library.addIcons(
            faBolt,
            faSpinner,
            faListCheck,
            faStop,
            faRocket,
            faDollar,
            faCoins,
            faArrowTrendUp,
            faFloppyDisk,
            faPuzzlePiece,
            faMinus,
            faMagnifyingGlassChart,
            faPause,
            faToolbox,
            faTimes,
            faChevronUp,
            faMagnifyingGlass,
            faFlask,
            faDownload,
            faRightFromBracket,
            faInfo,
            faCircleQuestion,
            faChevronDown,
            faClockRotateLeft,
            faArrowLeft,
            faPenToSquare,
            faUser,
            faRobot,
            faBuildingColumns,
            faShop,
            faBars,
            faTrash,
            faPlay,
            faPlus,
            faUsd,
            faEye,
            faCheck,
            faHome,
            faCaretDown,
            faCaretUp,
            faChevronRight,
            faStar,
            faCircleUser,
            faTrashCan,
            faSpellCheck,
            faBarsProgress,
            faMoneyCheckDollar,
            faEllipsis,
            faEllipsisVertical,
            faReceipt,
            faHeadset,
            faCommentDots,
            faRotateRight,
            faChevronLeft,
            faThumbsUp,
            faWandSparkles,
            faUserGear,
            faLink,
            faSun,
            faMoon,
            faCircleInfo,
            faTriangleExclamation,
            faFileInvoiceDollar,
            faKey,
        );
        this.routerService.init("/broker-accounts");
        this.router.events
            .pipe(
                filter((event) => {
                    return event instanceof NavigationEnd;
                }),
                map(() => this.activatedRoute),
                map((route: any) => {
                    while (route.firstChild) {
                        route = route.firstChild;
                    }

                    const errorCode = route.snapshot.queryParams["errorcode"];
                    if (errorCode) {
                        errorHandlerService.handleQueryError(errorCode, route.snapshot.queryParams);
                    }

                    return route;
                }),
                filter((route: any) => route.outlet === "primary"),
                mergeMap((route: any) => route.data),
            )
            .subscribe((event: any) => {
                let title = "White Hat Bots";
                if (event["title"]) {
                    title = `${event["title"]} - ${title}`;
                }
                this.titleService.setTitle(title);
            });

        this.translateService.setFallbackLang("en");
        this.translateService.use("en");
    }

    public ngOnInit(): void {
        // Initialize theme on component initialization
        this.themeService.getCurrentTheme();
    }
}
